import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getComprehensiveReportCSV = (
  userId,
  usergroupId,
  classId,
  trainingTypeId,
  categoryId,
  fromDate,
  toDate,
  countryId,
  stateId,
  cityId,
  storeId
) => {
  const url = `${
    apiConstants?.BASE_URL_1
  }/api/v1/UserBasedReports/GetUserReport?userId=${
    userId ? userId : 0
  }&usergroupId=${
    usergroupId ? usergroupId : 0
  }&shotClassId=${classId}&trainingTypeid=${
    trainingTypeId ? trainingTypeId : 0
  }&categoryId=${categoryId ? categoryId : null}&fromDate=${
    fromDate ? fromDate : null
  }&toDate=${toDate ? toDate : null}&countryId=${
    countryId ? countryId : 0
  }&stateId=${stateId ? stateId : 0}&cityId=${cityId ? cityId : 0}&storeId=${
    storeId ? storeId : 0
  }`;
  const encodedUrl = encodeURIComponent(url);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.TABULAR_REPORT.GET_COMPREHENSIVE_REPORT_CSV(encodedUrl)
  );
};

export default getComprehensiveReportCSV;
